import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Leaf, LogOut, Shield, Menu, X } from "lucide-react";
import { useState } from "react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header className="sticky top-0 z-50 glass border-b border-subtle/60" data-testid="site-header">
      <div className="container-page flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          <span className="w-9 h-9 rounded-full bg-moss text-white grid place-items-center group-hover:bg-moss-dark transition-colors">
            <Leaf size={18} />
          </span>
          <span className="font-heading text-xl font-semibold tracking-tight">Danashakaa.com</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-muted2">
          <Link to="/" className="hover:text-moss transition-colors" data-testid="nav-home">Home</Link>
          <a href="/#about" className="hover:text-moss transition-colors" data-testid="nav-about">About Dana</a>
          <a href="/#benefits" className="hover:text-moss transition-colors" data-testid="nav-benefits">Benefits</a>
          <a href="/#how-it-works" className="hover:text-moss transition-colors" data-testid="nav-how">How it works</a>
          <a href="/#faq" className="hover:text-moss transition-colors" data-testid="nav-faq">FAQ</a>
          {user && user.role !== "admin" && (
            <Link to="/dashboard" className="hover:text-moss transition-colors" data-testid="nav-dashboard">Dashboard</Link>
          )}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" className="inline-flex items-center gap-1.5 text-sm font-medium text-moss hover:text-moss-dark" data-testid="nav-admin">
                  <Shield size={16} /> Admin
                </Link>
              )}
              <button onClick={handleLogout} data-testid="logout-button"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-muted2 hover:text-ink transition-colors">
                <LogOut size={16} /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-ink hover:text-moss" data-testid="nav-login">Login</Link>
              <Link to="/register" className="bg-terra hover:bg-terra-dark text-white rounded-full px-5 py-2 text-sm font-semibold transition-all active:scale-95" data-testid="nav-register">
                Create Free Account
              </Link>
            </>
          )}
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-subtle bg-white/95 backdrop-blur-xl" data-testid="mobile-menu">
          <div className="container-page py-4 flex flex-col gap-3">
            <Link to="/" onClick={() => setOpen(false)} className="py-2">Home</Link>
            <a href="/#about" onClick={() => setOpen(false)} className="py-2">About Dana</a>
            <a href="/#how-it-works" onClick={() => setOpen(false)} className="py-2">How it works</a>
            <a href="/#faq" onClick={() => setOpen(false)} className="py-2">FAQ</a>
            {user ? (
              <>
                {user.role === "admin" ? (
                  <Link to="/admin" onClick={() => setOpen(false)} className="py-2">Admin dashboard</Link>
                ) : (
                  <Link to="/dashboard" onClick={() => setOpen(false)} className="py-2">Dashboard</Link>
                )}
                <button onClick={() => { handleLogout(); setOpen(false); }} className="py-2 text-left">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="py-2">Login</Link>
                <Link to="/register" onClick={() => setOpen(false)} className="bg-terra text-white rounded-full px-4 py-2 text-center font-semibold">
                  Create Free Account
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};
